module.exports = __webpack_public_path__ + "static/grafika6-28aab257da9b8b70c13f9d8a97d6120a.png";